<template>
  
    <List_Projetos />
  
</template>

<script>
import List_Projetos from '@/components/List_Projetos.vue';

export default {
  name: 'HomeView',
  components: {
    List_Projetos
}
}
</script>
